// Import from the package root (works with CRA's classic module resolution).
// Subpath imports like '@dnai/agg-core-fe/config' need moduleResolution
// 'bundler'/'node16'; the root re-exports everything the client needs.
import { defineBranding } from '@dnai/agg-core-fe'

export const branding = defineBranding({
    clientId: 'medirex',
    product: {
        name: 'Floxgen Aggregator',
        documentTitleSuffix: 'FLOXGEN AGG',
    },
    company: {
        legalName: 'MediXbank, n.o.',
        // The footer derives the label by swapping the scheme for 'www.'.
        website: 'https://medixbank.com',
        contactEmail: 'info@medirexgroupacademy.sk',
        copyrightName: 'DNAI',
        copyrightUrl: 'https://dnai.ai/',
    },
    footer: {
        contactLines: [
            'MediXbank, n.o.',
            'Novozámocká 1/67',
            '949 05 Nitra',
            'Reception: <a href="tel:+421220829136">+421 220 829 136</a>',
            '<a href="mailto:info@medixbank.com">info@medixbank.com</a>',
            '<a href="https://www.medixbank.com" target="_blank" rel="noopener noreferrer">www.medixbank.com</a>',
        ],
        legalLinks: [
            { label: 'Privacy Policy', href: '/' },
            { label: 'Terms & Conditions', href: '/' },
        ],
    },
    theme: { palette: 'floxgen' },
    localPopulation: {
        label: 'Slovak population',
        isoCode: '703',
    },
    externalTools: {
        kibanaUrl: 'https://kibana.agg.medirex.floxgen.dnai.ai/',
    },
})
